import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import BypassBlocks from '../CommonComponents/BypassBlocks';
import Paper from '@mui/material/Paper';
import {DRAWER_WIDTH} from './DashboardDrawer';
import {AppBar} from '@mui/material';
import Header from '../CommonComponents/Header';
import Footer from '../CommonComponents/Footer';
import DashboardDrawer from './DashboardDrawer';
import {FOOT_H} from '../../Theme/constants';
import {useTranslation} from 'react-i18next';

const PREFIX = 'MainDashboard';

const classes = {
  main: `${PREFIX}-main`,
  appBar: `${PREFIX}-appBar`,
  appBarHeader: `${PREFIX}-appBarHeader`,
  content: `${PREFIX}-content`,
  contentShift: `${PREFIX}-contentShift`,
  button: `${PREFIX}-button`,
  tabs: `${PREFIX}-tabs`,
  tabPanel: `${PREFIX}-tabPanel`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.main}`]: {
    background: theme.palette.grey[100],
  },

  [`& .${classes.appBar}`]: {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.common.white,
    width: '100%',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },

  [`& .${classes.appBarHeader}`]: {
    color: theme.palette.text.primary,
    background: 'white',
    position: 'static',
    top: 0,
    left: 'auto',
    width: '100%',
    padding: theme.spacing(2, 1, 1, '!important'),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  [`& .${classes.content}`]: {
    minHeight: `calc(100vh - ${FOOT_H}px)`,
    boxSizing: 'border-box',
    background: theme.palette.grey[100],
    padding: theme.spacing(3),
    flexGrow: 1,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: 0,
  },

  [`& .${classes.contentShift}`]: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: DRAWER_WIDTH,
  },

  [`& .${classes.button}`]: {
    height: 36,
  },

  [`& .${classes.tabs}`]: {
    borderBottom: '1px solid',
    borderBottomColor: theme.palette.grey[300],
  },

  [`& .${classes.tabPanel}`]: {
    '& .MuiBox-root': {
      width: '100%',
      padding: 0,
      boxSizing: 'border-box',
      overflowY: 'auto',
      boxShadow: theme.shadows[4],
    },
  }
}));

export default function MainDashboard(props){
  
  const {t,i18n} = useTranslation();


  const mainRef = React.createRef();
  const footerRef = React.createRef();

  const [open, setOpen] = React.useState({
      drawer: true,
    });
  const toggleDrawer = () => {
      setOpen({...open, drawer: !open.drawer});
    };

    React.useEffect(()=>{
      document.title=t('adminDashboard.title');
    }, [i18n.language]);
    
  return (
    (<Root>
      <BypassBlocks ref={{main: mainRef, footer: footerRef}} />
      <Header enableMenuAllPages={true} clickHandler={toggleDrawer}/>
      <main className={classes.main}>
        <DashboardDrawer
          open={open.drawer}
        />
        <Paper
          className={clsx(classes.content, classes.paper, {
            [classes.contentShift]: open.drawer,
          })}
          elevation={0}
        >
          <AppBar
            position="static"
            component="div"
            className={classes.appBar}
            ref={mainRef} tabIndex="-1"
          >
            {props.children}
          </AppBar>
        </Paper>
        <Footer open={open.drawer} ref={footerRef}/>
      </main>
    </Root>)
  );
}
MainDashboard.propTypes={
  children: PropTypes.node.isRequired,
}